// extracted by mini-css-extract-plugin
export default {"heading":"Products_heading__ROXLF","name":"Products_name__RQzm3","subcontent":"Products_subcontent__0Xk+O"};